import { createContext } from 'use-context-selector';

export interface GanttState {
    from: number;
    to: number;
}

export const GanttContext = createContext<GanttState>({ from: 0, to: 0 });
